export const createExternalFilesManager = (externalFiles, dataStores) => {
    return new ExternalFilesManagerImpl(externalFiles, dataStores);
};
class ExternalFilesManagerImpl {
    extFiles;
    extDataStores;
    constructor(extFiles, extDataStores) {
        this.extFiles = extFiles;
        this.extDataStores = extDataStores;
    }
    files() {
        return this.extFiles;
    }
    dataStores() {
        return this.extDataStores;
    }
}
